import { Pipe } from "@angular/core"

@Pipe({
    name: "pluralizeMediaType",
})
export class PluralizeMediaTypePipe {
    name_to_plural = {
        Collection: "Collections",
        Audio: "Audio",
        Video: "Videos",
        Image: "Images",
        Document: "Documents",
        Interactive: "Interactives",
        Webpage: "Webpages",
        "Media+Gallery": "Galleries",
        "Interactive+Lesson": "Interactive Lessons",
        "Lesson+Plan": "Lesson Plans",
    }

    transform(value: string): string {
        return this.name_to_plural[value]
    }
}
